export const SATISFACTION_ROUTE_SUFFIX = '/reports/all-rating';
export const ISSUE_KEY = '/:issueKey';
export const WORKLOAD_ROUTE_SUFFIX = '/reports/workload';
export const HOME_PAGE_SUFFIX = '/reports';
